import { useNavigate } from "react-router-dom";

export default function BackButton({ fallback = "/elios/dashboard" }) {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      onClick={() => navigate(-1)}
      onContextMenu={(event) => {
        event.preventDefault();
        navigate(fallback);
      }}
      className="inline-flex items-center rounded-md border border-gray-200 px-2 py-1 text-xs text-gray-600 hover:bg-gray-50"
    >
      Indietro
    </button>
  );
}
